const SPACE_REGEX = / /g

const removeSpaces = (value: string): string => value.replace(SPACE_REGEX, '')

const setValueKeepingCursor = ($input: HTMLInputElement, transform: (value: string) => string): void => {
  const cursorPosition = $input.selectionStart ?? $input.value.length
  const cursorPositionAfterTransform = transform($input.value.slice(0, cursorPosition)).length

  $input.value = transform($input.value)
  $input.setSelectionRange(cursorPositionAfterTransform, cursorPositionAfterTransform)
}

// Function removes spaces from the password value and keeps the cursor where the user is typing.
export const handlePasswordInput = ($passwordInput: HTMLInputElement): void => {
  const { value } = $passwordInput

  if (value === removeSpaces(value)) return

  setValueKeepingCursor($passwordInput, removeSpaces)
}

export const bindPasswordInput = ($passwordInput: HTMLInputElement): void => {
  if (!$passwordInput) return

  $passwordInput.addEventListener('input', () => handlePasswordInput($passwordInput))
}
